(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-new-ingredients"] && !Shopify.designMode) return;
  try {
    (function() {
  var section = document.currentScript.closest('[data-section-id]') 
                || document.currentScript.closest('.shopify-section');
  
  function initSwiper() {
    if (typeof Swiper === 'undefined') return;
    var el = section ? section.querySelector('.ingredients-swiper') : document.querySelector('.ingredients-swiper');
    if (!el || el.swiper) return;

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        768: { slidesPerView: 1 },
        1024: { slidesPerView: 1 }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwiper);
  } else {
    initSwiper();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
